import React from 'react'
import DoneTodos from './DoneTodos'
import InProcessTodos from './InProcessTodos'
import UndoneTodos from './UndoneTodos'

const TodoList = () => {
  return (
    <div className='d-flex todo_lists'>
        <UndoneTodos />
        <InProcessTodos />
        <DoneTodos />
    </div>
  )
}

export default TodoList